var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "singapore-dollar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.651,
    height: 21.651,
    viewBox: "0 0 21.651 21.651",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M329.16,265.883A1.281,1.281,0,0,0,328,264.76v2.246A1.281,1.281,0,0,0,329.16,265.883Z",
    transform: "translate(-313.695 -253.511)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M42.819,32a10.825,10.825,0,1,0,7.655,3.171A10.825,10.825,0,0,0,42.819,32ZM33.927,43.211a.387.387,0,1,1,.387-.387A.387.387,0,0,1,33.927,43.211Zm.515-1.866a.387.387,0,0,1-.762-.134,9.291,9.291,0,0,1,7.526-7.526.387.387,0,1,1,.134.762A8.516,8.516,0,0,0,34.441,41.345ZM40.113,46.3c-1.517,0-2.706-.849-2.706-1.933a.387.387,0,1,1,.773,0c0,.629.885,1.16,1.933,1.16s1.933-.531,1.933-1.16-.885-1.16-1.933-1.16c-1.517,0-2.706-.849-2.706-1.933s1.189-1.933,2.706-1.933,2.706.849,2.706,1.933a.387.387,0,1,1-.773,0c0-.629-.885-1.16-1.933-1.16s-1.933.531-1.933,1.16.885,1.16,1.933,1.16c1.517,0,2.706.849,2.706,1.933S41.63,46.3,40.113,46.3Zm2.706,5.8a.387.387,0,1,1,.387-.387A.387.387,0,0,1,42.819,52.1Zm0-17.784a.387.387,0,1,1,.387-.387A.387.387,0,0,1,42.819,34.319Zm.773,6.959a2.079,2.079,0,0,1,1.933-1.906v-.8a.387.387,0,0,1,.773,0v.8a2.079,2.079,0,0,1,1.933,1.906.387.387,0,1,1-.773,0,1.281,1.281,0,0,0-1.16-1.123v2.31a1.906,1.906,0,1,1,0,3.811v.8a.387.387,0,1,1-.773,0v-.8a2.079,2.079,0,0,1-1.933-1.906.387.387,0,1,1,.773,0,1.281,1.281,0,0,0,1.16,1.123v-2.31A2.079,2.079,0,0,1,43.592,41.278Zm8.119,1.16a.387.387,0,1,1-.387.387A.387.387,0,0,1,51.711,42.438Zm-.067,1.552a.387.387,0,0,1,.314.448,9.291,9.291,0,0,1-7.526,7.526A.387.387,0,1,1,44.3,51.2a8.516,8.516,0,0,0,6.9-6.9A.387.387,0,0,1,51.644,43.99Z",
    transform: "translate(-31.993 -31.999)",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M289.16,200.76a1.124,1.124,0,1,0,0,2.246Z",
    transform: "translate(-275.628 -192.604)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredit);
export default __webpack_public_path__ + "static/media/Credit.a229958d71a5dd28ad7b822985126f23.svg";
export { ForwardRef as ReactComponent };